import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {RadioGroup} from 'react-radio-group';
import FormField from './FormField';
import RadioButton from '../RadioButton';

export default class FormRadioGroup extends Component {
    static propTypes = {
        className: PropTypes.string,
        label: PropTypes.string,
        fieldKey: PropTypes.string,
        fieldName: PropTypes.string,
        values: PropTypes.array.isRequired,
        selected: PropTypes.any,
        error: PropTypes.string,
        onChange: PropTypes.func,
        disabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),
        radioButtonClassName: PropTypes.string,
        activeRadioButtonClassName: PropTypes.string,
        itemIdentityKey: PropTypes.string,
        groupClassName: PropTypes.string,
    };

    static defaultProps = {
        values: [],
        itemIdentityKey: 'value',
        groupClassName: null,
    };

    render() {
        const {
            label,
            className,
            error,
            fieldKey,
            selected,
            groupClassName,
        } = this.props;

        return (
            <FormField label={label}
                className={className}
                error={error}>
                <RadioGroup
                    name={fieldKey}
                    selectedValue={selected}
                    onChange={this.handleChange}
                    className={groupClassName}
                >
                    {this.renderButtons()}
                </RadioGroup>
            </FormField>
        )
    }

    renderButtons() {
        const {
            values,
            fieldKey,
            error,
            disabled,
            radioButtonClassName,
            activeRadioButtonClassName,
            selected,
            itemIdentityKey,
        } = this.props;
        return values.map((item, index) => {
            const isDisabled = Array.isArray(disabled)
                ? disabled.includes(item[itemIdentityKey])
                : disabled;

            return (
                <RadioButton
                    fieldKey={fieldKey}
                    {...item}
                    error={error}
                    disabled={isDisabled}
                    key={index}
                    className={radioButtonClassName}
                    activeClassName={activeRadioButtonClassName}
                    isActive={item.value === selected}
                />
            );
        });
    }

    handleChange = value => {
        const {onChange, fieldKey, fieldName} = this.props;
        onChange(fieldKey || fieldName, {target: {value}});
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormRadioGroup.js